/*
 * VG Cyber Week 2026: muestra/oculta lo marcado con [data-vg-cyber] según el reloj de window.VGCyber
 * (snippets/vg-cyber-boot.liquid, que también trae el truco ?cyber_preview para probar).
 * [data-vg-cyber] = solo durante; [data-vg-cyber="window"] = antes y durante; [data-vg-cyber-phase] = before/during.
 * Corre las cuentas regresivas y el "Precio Cyber" por variante.
 */
(function () {
  'use strict';
  var cfg = window.VGCyber;
  if (!cfg || !cfg.now || window.VGCyberBooted) return;
  window.VGCyberBooted = true;
  var start = cfg.start;
  var end = cfg.end;
  if (isNaN(start) || isNaN(end)) return;
  function clock() { return cfg.now(); }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    return (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  // Variante que se compra: la del formulario de la ficha (Horizon la actualiza al cambiar de opción); la URL va de respaldo.
  function variantFor(el) {
    var scope = (el.closest && el.closest('product-info, .product-information, main')) || document;
    var input = scope.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;
    return new URLSearchParams(window.location.search).get('variant');
  }

  // Precio Cyber fijo: el bloque solo sale si la variante elegida tiene rebaja real (mapa de variantes con custom.cyber_rebaja).
  function gateOk(el) {
    var real;
    try { real = JSON.parse(el.getAttribute('data-vg-cyber-real') || '{}'); } catch (e) { return false; }
    var id = variantFor(el);
    return !!(id && real[id]);
  }

  function paint() {
    var now = clock();
    var before = now < start;
    var during = now >= start && now <= end;
    var changed = false;
    var els = document.querySelectorAll('[data-vg-cyber]');
    for (var i = 0; i < els.length; i++) {
      var show = els[i].getAttribute('data-vg-cyber') === 'window' ? (before || during) : during;
      if (show && els[i].hasAttribute('data-vg-cyber-real')) show = gateOk(els[i]);
      if (els[i].hidden === show) { els[i].hidden = !show; changed = true; }
    }
    // Si la píldora del menú apareció/desapareció, Horizon debe recalcular qué ítems caben (si no, el menú se parte en 2 filas)
    if (changed) {
      var lists = document.querySelectorAll('overflow-list');
      for (var o = 0; o < lists.length; o++) lists[o].dispatchEvent(new CustomEvent('reflow', { detail: {} }));
    }
    var phase = document.querySelectorAll('[data-vg-cyber-phase]');
    for (var k = 0; k < phase.length; k++) {
      var want = phase[k].getAttribute('data-vg-cyber-phase') === (before ? 'before' : 'during');
      if (phase[k].hidden === want) phase[k].hidden = !want;
    }
    var txt = fmt(before ? start - now : end - now);
    var clocks = document.querySelectorAll('[data-vg-cyber-clock]');
    // Solo si cambió: evita que el MutationObserver de abajo entre en bucle.
    for (var j = 0; j < clocks.length; j++) if (clocks[j].textContent !== txt) clocks[j].textContent = txt;
    var on = before || during;
    // Durante: html.vg-cyber-on oculta el teaser de BIENVENIDA10 (Klaviyo), que no se combina con el Cyber.
    document.documentElement.classList.toggle('vg-cyber-on', during);
    syncPrices();
    return on;
  }

  // Precio Cyber de la ficha: sigue a la variante seleccionada (Horizon solo re-renderiza el precio base).
  function syncPrices() {
    var now = clock();
    var during = now >= start && now <= end;
    var boxes = document.querySelectorAll('[data-vg-cyber-prices]');
    for (var i = 0; i < boxes.length; i++) {
      var map;
      try { map = JSON.parse(boxes[i].getAttribute('data-vg-cyber-prices')); } catch (e) { continue; }
      var id = variantFor(boxes[i]);
      var amount = boxes[i].querySelector('[data-vg-cyber-amount]');
      if (id && map[id] && amount && amount.textContent !== map[id]) amount.textContent = map[id];
      if (boxes[i].hasAttribute('data-vg-cyber-real')) {
        var real;
        try { real = JSON.parse(boxes[i].getAttribute('data-vg-cyber-real') || '{}'); } catch (e) { real = {}; }
        var want = during && !!(id && real[id]);
        // Solo si cambió: paint() usa la misma regla, así que no hay vaivén con el MutationObserver.
        if (boxes[i].hidden === want) boxes[i].hidden = !want;
      }
    }
  }

  // Solo lo que marca el Cyber; el resto de los cambios del DOM (hidratación de Horizon, carruseles, apps) se ignora.
  var CYBER_SEL = '[data-vg-cyber], [data-vg-cyber-phase], [data-vg-cyber-clock], [data-vg-cyber-prices]';

  function phaseAt(now) { return now < start ? 'before' : now <= end ? 'during' : 'after'; }

  // Tic de cada segundo: solo relojes y precio por variante. Lo pesado (mostrar/ocultar) corre en paint().
  function tick() {
    var now = clock();
    var txt = fmt(now < start ? start - now : end - now);
    var clocks = document.querySelectorAll('[data-vg-cyber-clock]');
    for (var j = 0; j < clocks.length; j++) if (clocks[j].textContent !== txt) clocks[j].textContent = txt;
    syncPrices();
  }

  function hasCyberNode(records) {
    for (var r = 0; r < records.length; r++) {
      // morph de Horizon puede devolver el "hidden" del servidor a un nodo que ya existía
      if (records[r].type === 'attributes') {
        if (records[r].target.nodeType === 1 && records[r].target.matches(CYBER_SEL)) return true;
        continue;
      }
      var added = records[r].addedNodes;
      for (var n = 0; n < added.length; n++) {
        var node = added[n];
        if (node.nodeType !== 1) continue;
        if (node.matches(CYBER_SEL) || node.querySelector(CYBER_SEL)) return true;
      }
    }
    return false;
  }

  function boot() {
    var lastPhase = phaseAt(clock());
    paint();
    var timer = setInterval(function () {
      var phase = phaseAt(clock());
      if (phase !== lastPhase) {
        lastPhase = phase;
        paint();
      } else {
        tick();
      }
      if (phase === 'after') clearInterval(timer);
    }, 1000);
    // Horizon re-renderiza bloques (variante, filtros): repintar solo si llegó algo marcado con data-vg-cyber*.
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function (records) {
        if (pending || !hasCyberNode(records)) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; paint(); });
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    }
  }

  // Cambio de variante: repinta enseguida y de nuevo cuando Horizon termina de actualizar formulario y URL.
  var vt1, vt2;
  function soon() { clearTimeout(vt1); clearTimeout(vt2); vt1 = setTimeout(syncPrices, 60); vt2 = setTimeout(syncPrices, 700); }
  document.addEventListener('variant:update', soon, true);
  document.addEventListener('input', function (e) { if (e.target && e.target.name === 'id') soon(); }, true);
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker, [data-variant-picker], form')) soon(); });
  window.addEventListener('popstate', soon);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
